for (const element of document.querySelectorAll('.vp-block-master-details')) {
  const list = element.querySelector('.list')
  const links = list.querySelectorAll('.master')
  for (const link of links) {
    link.addEventListener('click', (e) => {
      for (const on of list.querySelectorAll('.on')) {
        on.classList.remove('on')
      }
      link.classList.add('on')
      const details = link.nextElementSibling
      if (details) {
        details.classList.add('on')
      }
    })
  }
}
